export { default as WhyChooseCard } from "./WhyChooseCard";
